import axios from 'axios';

import IJobsDownloadTemplate from '../types/IJobsDownloadTemplate';

export const saveJobsDownloadTemplates = (payload: IJobsDownloadTemplate) =>
  axios.post('/jobsearch/api/download-settings-template/save', payload);

export const getJobsDownloadTemplates = () =>
  axios.get('/jobsearch/api/download-settings-template/get-templates');

export const getJobsDownloadTemplateById = (id: string) =>
  axios.get(`/jobsearch/api/download-settings-template/get-template/${id}`);

export const deleteDataDownloadSettingsTemplate = (templateId: string) =>
  axios.delete(`/jobsearch/api/download-settings-template/delete-template/${templateId}`);

export const hideDataDownloadSettingsTemplate = (templateId: string, isHidden: boolean) =>
  axios.post(`/jobsearch/api/download-settings-template/hide-template/${templateId}/${isHidden}`);

export const favoriteDataDownloadSettingsTemplate = (templateId: string, isFavorite: boolean) =>
  axios.post(
    `/jobsearch/api/download-settings-template/favorite-template/${templateId}/${isFavorite}`
  );
